import AppClient from "./components/AppClient"

function App() {
  return (
    <AppClient />
  );
}

export default App;
